import React from 'react';

import { Anchor, FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Section } from '../../../../models/index';
import YesAndNo from '../../../Widgets/YesAndNo';
import { SECTION_8_HOUSING_VOUCHER } from '../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function Section8HousingVoucher({ section, setSectionValues }: Props): JSX.Element {
  function onNoVoucher(): void {
    setSectionValues({
      [SECTION_8_HOUSING_VOUCHER.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesVoucher(): void {
    setSectionValues({
      [SECTION_8_HOUSING_VOUCHER.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <>
      <FormField
        required
        label={<Label>Will the tenant use a Housing Choice voucher (i.e., a Section 8 voucher)?</Label>}
        description={
          <FormHelp>
            <span>
              The Housing Choice voucher program (Section 8) is a subsidy program administered by local housing agencies
              to help income restricted families find safe housing. Landlords must go through an approval process to
              accept Housing Choice Vouchers.{' '}
              <Anchor
                href="https://www.hud.gov/program_offices/public_indian_housing/programs/hcv/landlord"
                target="_blank"
                rel="noopener noreferrer"
                css={{ font: 'inherit' }}
              >
                Learn more
              </Anchor>
            </span>
          </FormHelp>
        }
        control={
          <YesAndNo
            yesHandler={onYesVoucher}
            noHandler={onNoVoucher}
            yesActive={section.getFieldValue(SECTION_8_HOUSING_VOUCHER.FIELD_NAME.IS_ENABLED)}
          />
        }
      />
    </>
  );
}
